import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminCouponRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'financial.coupons.'

  index() {
    return this.ziggyRoute('index')
  }

  create() {
    return this.ziggyRoute('create')
  }

  store() {
    return this.ziggyRoute('store')
  }

  edit(couponId: number) {
    return this.ziggyRoute('edit', couponId)
  }

  update(couponId: number) {
    return this.ziggyRoute('update', couponId)
  }

}

@vsingleton()
export class AdminCouponApiRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'api.'

  couponSearch() {
    return this.ziggyRoute('coupon_search')
  }
}
